import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export default function LinkedinIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      width: t1,
      height: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const width = t1 === undefined ? 28 : t1;
  const height = t2 === undefined ? 28 : t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M14.03 28h-.06C6.266 28 0 21.733 0 14.03v-.06C0 6.266 6.267 0 13.97 0h.06C21.734 0 28 6.267 28 13.97v.06C28 21.734 21.733 28 14.03 28zM13.97.948C6.788.948.947 6.788.947 13.969v.062c0 7.18 5.84 13.021 13.021 13.021h.062c7.18 0 13.021-5.84 13.021-13.021v-.062c0-7.18-5.84-13.021-13.021-13.021h-.062z" fill="#000" />;
    t4 = <path d="M6.925 9.465a1.607 1.607 0 01-.533-1.227c0-.487.178-.915.533-1.246.357-.331.815-.497 1.377-.497.563 0 1.003.166 1.359.497.356.33.533.747.533 1.246 0 .5-.178.897-.533 1.227-.357.331-.809.497-1.359.497-.55 0-1.02-.166-1.377-.497zm2.97 1.898v10.141H6.69V11.363h3.205zM20.562 12.365c.698.758 1.047 1.799 1.047 3.123v5.837h-3.043V15.9c0-.668-.174-1.188-.52-1.557-.345-.37-.812-.556-1.395-.556-.584 0-1.05.185-1.397.556-.346.37-.519.889-.519 1.557v5.425h-3.061v-9.99h3.061v1.324c.31-.441.728-.79 1.253-1.047.525-.257 1.116-.385 1.772-.385 1.17 0 2.104.38 2.802 1.138z" fill="#000" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== height || $[7] !== props || $[8] !== width) {
    t5 = <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t3}{t4}</svg>;
    $[6] = height;
    $[7] = props;
    $[8] = width;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}